import { Download } from 'lucide-react'
import { Book } from '../../types'
import BookCard from '../BookCard'


interface BookListProps {
  books: Book[]
}

export default function BookList({ books }: BookListProps) {

  // Card visuals are now handled by shared BookCard

  if (books.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="mx-auto h-12 w-12 bg-muted rounded-full flex items-center justify-center mb-4">
          <Download className="h-6 w-6 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium text-muted-foreground mb-2">
          No books yet
        </h3>
        <p className="text-sm text-muted-foreground">
          Upload your first book to get started with translation and simplification.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {books.map((book) => (
          <BookCard key={book.id} book={book} variant="user-book" />
        ))}
      </div>
    </div>
  )
}
